import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { addSchemaKeyHook, SchemaBase, getDefaultSchemaOptions, SchemaConstructorArgs } from "../../schemaBase.js";
import { validate, getZodSchemaFromClass } from "../../../zod-decorator/index.js";
import { type DtoValidatorTypes } from "../../validatableClass.js";
import { SoilMoistureEntryFieldsWithDefaults, SoilMoistureEntrySchemaTypes } from "../../types/soilMoistureEntry.d.js";

const SCHEMA_KEY = "SoilMoistureEntry" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<SoilMoistureEntry>>(...addSchemaKeyHook(SCHEMA_KEY))
/**
 * @deprecated - pretty sure we actually don't need this one, but migrating it just in case
 */
export class SoilMoistureEntry extends SchemaBase<SoilMoistureEntry, SoilMoistureEntryFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.coerce.date() })
    @prop({ type: () => Date, required: true })
    public date!: Date;

    @validate({ zodValidator: z.number() })
    @prop({ type: () => Number, required: true })
    public moistureReading!: number;

    static getters = {} as const satisfies Record<string, (self: SoilMoistureEntry) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<SoilMoistureEntrySchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<SoilMoistureEntry, SoilMoistureEntryFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

SoilMoistureEntry.dtoValidators = getZodSchemaFromClass(
    SoilMoistureEntry,
) as unknown as DtoValidatorTypes<SoilMoistureEntrySchemaTypes>;
